import { serializeError } from 'serialize-error';
import Debug from './Debug';
/*
 *maxLogJsonLength is set to 1000 to reduce Payload size for cloudwatch metrics.
 * Even if we include bigger message, stack is obfuscated in release build
 * helping us with only message
 */
const maxLogJsonLength = 1000;
function errorToLogObject(e) {
    if (e == null) {
        return { message: 'empty exception' };
    }
    let result;
    if (typeof e === 'string') {
        result = { message: e };
    }
    else {
        const enumerableError = serializeError(e);
        enumerableError.stack = undefined; // stack is obfuscated in release build
        let json = JSON.stringify(enumerableError);
        if (json.length > maxLogJsonLength) {
            json = json.substring(0, maxLogJsonLength);
        }
        result = {
            message: e.message || String(e),
            json,
            stack: __DEV__ ? e.stack : undefined,
        };
    }
    return result;
}
const toErrorMessage = (err) => {
    if (!err) {
        return '';
    }
    if (err instanceof Error) {
        const { message } = err;
        return message;
    }
    if (typeof err === 'string') {
        return err;
    }
    if (typeof err === 'object') {
        return JSON.stringify(err);
    }
    // although less likely, if this happens we don't want to loose data
    // so we are loudly notifying developer about unknown type of exception
    Debug.error('Unparsed exception value');
    return `${err}`;
};
export { errorToLogObject, toErrorMessage };
//# sourceMappingURL=ErrorHelper.js.map